import { render, staticRenderFns } from "./RaceCardTrainerJockeyCombo.vue?vue&type=template&id=8e4244d8&scoped=true"
import script from "./RaceCardTrainerJockeyCombo.vue?vue&type=script&lang=js"
export * from "./RaceCardTrainerJockeyCombo.vue?vue&type=script&lang=js"
import style0 from "./RaceCardTrainerJockeyCombo.vue?vue&type=style&index=0&id=8e4244d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4244d8",
  null
  
)

export default component.exports